import "./animated-visual-swap.scss";

import { renderToStaticMarkup } from "react-dom/server";
import SocialStart from "@frontend/images/SocialStart";
import { useLayoutEffect, useRef } from "react";

import { renderCurtain, renderTripleCircles, renderTriangleMorph, renderDiamondSquare, renderGearsPanel, renderGearsPanelRight, renderCircleRails, renderOrbitQuads, renderFrameRailsUp, renderFrameRailsSpread, renderDiamondHatch, renderShelfAnalysis, renderPackageAnalysis, renderRetailAuditInPieteleTinta, renderStrategiaDeExport, renderWebsiteAnalysis, renderBannerAnalysis, renderVideoSpotAnalysis, renderConfusionAnalysis, renderMarketingStrategyElaboration, renderCommunicationMessageTesting, renderCampaignImpactEvaluation, renderCommunicationCampaignImpactEvaluation, renderPublicProgramImpactEvaluation, renderBlindTasting, renderExportMarketVolumeEstimation, renderTargetMarketIdentification, renderExportMarketResearch, renderTargetMarketPartnerIdentification, } from "./renderers/shapeRenderers";
import { renderSocialPhenomenon, renderSocialEtnography, renderTestareaCandidatilorPolitici, renderSocialPopulation, renderSocialMassMedia, renderSocialAcademic, renderLongitudinalStudy, } from "./renderers/socialRenderers";
import { renderMethodologyQuantitative, renderMethodologyQualitative, renderMethodologyAnalysis, renderMethodologyExperiment, renderMethodologyOffice, renderMethodologyAdvanced, } from "./renderers/methodologyRenderers";
import { renderNps, renderNotority, renderPyramid, renderAtitude, renderConsumerProfile, renderSegmentation, renderPriceTesting, renderPackageTesting, renderProductTest, } from "./renderers/productRenderers";
import { renderMarketing, renderPolitics, renderMarket, renderNeuro, renderJourney, renderMystery, } from "./renderers/basicRenderers";
import { renderForecasting, renderSocial, renderSeo, } from "./renderers/specialRenderers";
import { attachInteractive, INK, PINK, } from "./renderers/helpers";


const SOCIAL_SVG_MARKUP = renderToStaticMarkup(<SocialStart />);

const RENDERERS = {
    "html-preview-ellipse": () => renderMarketing(),
    "html-preview-neuro": () => renderNeuro(),
    "html-preview-journey": () => renderJourney(),
    "html-preview-mystery": () => renderMystery(),
    "html-preview-curtain": () => renderCurtain(),
    "html-preview-diamond-square": () => renderDiamondSquare(),
    "html-preview-triple-circles": () => renderTripleCircles(),
    "html-preview-triangle-morph": () => renderTriangleMorph(),
    "html-preview-gears-panel": () => renderGearsPanel(),
    "html-preview-gears-panel-right": () => renderGearsPanelRight(),
    "html-preview-circle-rails": () => renderCircleRails(),
    "html-preview-orbit-quads": () => renderOrbitQuads(),
    "html-preview-frame-rails-up": () => renderFrameRailsUp(),
    "html-preview-frame-rails-spread": () => renderFrameRailsSpread(),
    "html-preview-shelf-analysis": () => renderShelfAnalysis(),
    "html-preview-package-analysis": () => renderPackageAnalysis(),
    "html-preview-retail-audit-in-pietele-tinta": () => renderRetailAuditInPieteleTinta(),
    "html-preview-strategia-de-export": () => renderStrategiaDeExport(),
    "html-preview-website-analysis": () => renderWebsiteAnalysis(),
    "html-preview-banner-analysis": () => renderBannerAnalysis(),
    "html-preview-video-spot-analysis": () => renderVideoSpotAnalysis(),
    "html-preview-confusion-analysis": () => renderConfusionAnalysis(),
    "html-preview-marketing-strategy-elaboration": () => renderMarketingStrategyElaboration(),
    "html-preview-communication-message-testing": () => renderCommunicationMessageTesting(),
    "html-preview-campaign-impact-evaluation": () => renderCampaignImpactEvaluation(),
    "html-preview-communication-campaign-impact-evaluation": () => renderCommunicationCampaignImpactEvaluation(),
    "html-preview-public-program-impact-evaluation": () => renderPublicProgramImpactEvaluation(),
    "html-preview-blind-tasting": () => renderBlindTasting(),
    "html-preview-export-market-volume-estimation": () => renderExportMarketVolumeEstimation(),
    "html-preview-target-market-identification": () => renderTargetMarketIdentification(),
    "html-preview-export-market-research": () => renderExportMarketResearch(),
    "html-preview-target-market-partner-identification": () => renderTargetMarketPartnerIdentification(),
    "html-preview-diamond-hatch": () => renderDiamondHatch(),
    "html-preview-rainbow": () => renderPolitics(),
    "html-preview-prism": () => renderSeo(),
    "html-preview-frame": () => renderMarket(),
    "html-preview-web": () => renderForecasting(),
    "html-preview-nps": () => renderNps(),
    "html-preview-notority": () => renderNotority(),
    "html-preview-pyramid": () => renderPyramid(),
    "html-preview-atitude": () => renderAtitude(),
    "html-preview-consumer-profile": () => renderConsumerProfile(),
    "html-preview-segmentation": () => renderSegmentation(),
    "html-preview-price-testing": () => renderPriceTesting(),
    "html-preview-package-testing": () => renderPackageTesting(),
    "html-preview-product-test": () => renderProductTest(),
    "html-preview-social-phenomenon": () => renderSocialPhenomenon(),
    "html-preview-social-etnography": () => renderSocialEtnography(),
    "html-preview-testarea-candidatilor-politici": () => renderTestareaCandidatilorPolitici(),
    "html-preview-social-population": () => renderSocialPopulation(),
    "html-preview-social-mass-media": () => renderSocialMassMedia(),
    "html-preview-social-academic": () => renderSocialAcademic(),
    "html-preview-longitudinal-study": () => renderLongitudinalStudy(),
    "html-preview-methodology-quantitative": () => renderMethodologyQuantitative(),
    "html-preview-methodology-qualitative": () => renderMethodologyQualitative(),
    "html-preview-methodology-analysis": () => renderMethodologyAnalysis(),
    "html-preview-methodology-experiment": () => renderMethodologyExperiment(),
    "html-preview-methodology-office": () => renderMethodologyOffice(),
    "html-preview-methodology-advanced": () => renderMethodologyAdvanced(),
    "html-preview-scatter": (props) =>
        renderSocial(props?.socialSvgMarkup || SOCIAL_SVG_MARKUP),
};

export const ellipseAnimation = {
    trigger: "hover",
    renderer: "html-preview-ellipse",
};
export const webAnimation = { trigger: "hover", renderer: "html-preview-web" };
export const scatterAnimation = {
    trigger: "hover",
    renderer: "html-preview-scatter",
};
export const neuroAnimation = {
    trigger: "hover",
    renderer: "html-preview-neuro",
};
export const journeyAnimation = {
    trigger: "hover",
    renderer: "html-preview-journey",
};
export const mysteryAnimation = {
    trigger: "hover",
    renderer: "html-preview-mystery",
};
export const curtainAnimation = {
    trigger: "hover",
    renderer: "html-preview-curtain",
};
export const diamondSquareAnimation = {
    trigger: "hover",
    renderer: "html-preview-diamond-square",
};
export const tripleCirclesAnimation = {
    trigger: "hover",
    renderer: "html-preview-triple-circles",
};
export const triangleMorphAnimation = {
    trigger: "hover",
    renderer: "html-preview-triangle-morph",
};
export const gearsPanelAnimation = {
    trigger: "hover",
    renderer: "html-preview-gears-panel",
};
export const gearsPanelRightAnimation = {
    trigger: "hover",
    renderer: "html-preview-gears-panel-right",
};
export const circleRailsAnimation = {
    trigger: "hover",
    renderer: "html-preview-circle-rails",
};
export const orbitQuadsAnimation = {
    trigger: "hover",
    renderer: "html-preview-orbit-quads",
};
export const frameRailsUpAnimation = {
    trigger: "hover",
    renderer: "html-preview-frame-rails-up",
};
export const diamondHatchAnimation = {
    trigger: "hover",
    renderer: "html-preview-diamond-hatch",
};
export const frameRailsSpreadAnimation = {
    trigger: "hover",
    renderer: "html-preview-frame-rails-spread",
};
export const shelfAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-shelf-analysis",
};
export const packageAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-package-analysis",
};
export const retailAuditInPieteleTintaAnimation = {
    trigger: "hover",
    renderer: "html-preview-retail-audit-in-pietele-tinta",
};
export const strategiaDeExportAnimation = {
    trigger: "hover",
    renderer: "html-preview-strategia-de-export",
};
export const websiteAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-website-analysis",
};
export const bannerAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-banner-analysis",
};
export const videoSpotAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-video-spot-analysis",
};
export const confusionAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-confusion-analysis",
};
export const marketingStrategyElaborationAnimation = {
    trigger: "hover",
    renderer: "html-preview-marketing-strategy-elaboration",
};
export const communicationMessageTestingAnimation = {
    trigger: "hover",
    renderer: "html-preview-communication-message-testing",
};
export const campaignImpactEvaluationAnimation = {
    trigger: "hover",
    renderer: "html-preview-campaign-impact-evaluation",
};
export const communicationCampaignImpactEvaluationAnimation = {
    trigger: "hover",
    renderer: "html-preview-communication-campaign-impact-evaluation",
};
export const publicProgramImpactEvaluationAnimation = {
    trigger: "hover",
    renderer: "html-preview-public-program-impact-evaluation",
};
export const blindTastingAnimation = {
    trigger: "hover",
    renderer: "html-preview-blind-tasting",
};
export const exportMarketVolumeEstimationAnimation = {
    trigger: "hover",
    renderer: "html-preview-export-market-volume-estimation",
};
export const targetMarketIdentificationAnimation = {
    trigger: "hover",
    renderer: "html-preview-target-market-identification",
};
export const exportMarketResearchAnimation = {
    trigger: "hover",
    renderer: "html-preview-export-market-research",
};
export const targetMarketPartnerIdentificationAnimation = {
    trigger: "hover",
    renderer: "html-preview-target-market-partner-identification",
};
export const frameAnimation = {
    trigger: "hover",
    renderer: "html-preview-frame",
};
export const rainbowAnimation = {
    trigger: "hover",
    renderer: "html-preview-rainbow",
};
export const prismAnimation = {
    trigger: "hover",
    renderer: "html-preview-prism",
};
export const npsAnimation = {
    trigger: "hover",
    renderer: "html-preview-nps",
};
export const notorityAnimation = {
    trigger: "hover",
    renderer: "html-preview-notority",
};
export const pyramidAnimation = {
    trigger: "hover",
    renderer: "html-preview-pyramid",
};
export const atitudeAnimation = {
    trigger: "hover",
    renderer: "html-preview-atitude",
};
export const consumerProfileAnimation = {
    trigger: "hover",
    renderer: "html-preview-consumer-profile",
};
export const segmentationAnimation = {
    trigger: "hover",
    renderer: "html-preview-segmentation",
};
export const priceTestingAnimation = {
    trigger: "hover",
    renderer: "html-preview-price-testing",
};
export const packageTestingAnimation = {
    trigger: "hover",
    renderer: "html-preview-package-testing",
};
export const productTestAnimation = {
    trigger: "hover",
    renderer: "html-preview-product-test",
};
export const socialPhenomenonAnimation = {
    trigger: "hover",
    renderer: "html-preview-social-phenomenon",
};
export const socialEtnographyAnimation = {
    trigger: "hover",
    renderer: "html-preview-social-etnography",
};
export const socialPopulationAnimation = {
    trigger: "hover",
    renderer: "html-preview-social-population",
};
export const testareaCandidatilorPoliticiAnimation = {
    trigger: "hover",
    renderer: "html-preview-testarea-candidatilor-politici",
};
export const socialMassMediaAnimation = {
    trigger: "hover",
    renderer: "html-preview-social-mass-media",
};
export const socialAcademicAnimation = {
    trigger: "hover",
    renderer: "html-preview-social-academic",
};
export const longitudinalStudyAnimation = {
    trigger: "hover",
    renderer: "html-preview-longitudinal-study",
};
export const methodologyQuantitativeAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-quantitative",
};
export const methodologyQualitativeAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-qualitative",
};
export const methodologyAnalysisAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-analysis",
};
export const methodologyExperimentAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-experiment",
};
export const methodologyOfficeAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-office",
};
export const methodologyAdvancedAnimation = {
    trigger: "hover",
    renderer: "html-preview-methodology-advanced",
};

export const SERVICE_ANIMATION_BY_ID = {
    1: ellipseAnimation,
    2: rainbowAnimation,
    3: prismAnimation,
    4: frameAnimation,
    5: webAnimation,
    6: scatterAnimation,
    7: neuroAnimation,
    8: journeyAnimation,
    9: mysteryAnimation,
    10: curtainAnimation,
    11: diamondSquareAnimation,
    12: tripleCirclesAnimation,
    13: triangleMorphAnimation,
    14: gearsPanelAnimation,
    15: gearsPanelRightAnimation,
    16: circleRailsAnimation,
    17: orbitQuadsAnimation,
    18: frameRailsUpAnimation,
    19: diamondHatchAnimation,
    35: frameRailsSpreadAnimation,
    36: shelfAnalysisAnimation,
    37: packageAnalysisAnimation,
    52: retailAuditInPieteleTintaAnimation,
    53: strategiaDeExportAnimation,
    38: websiteAnalysisAnimation,
    39: bannerAnalysisAnimation,
    40: videoSpotAnalysisAnimation,
    41: confusionAnalysisAnimation,
    42: marketingStrategyElaborationAnimation,
    43: communicationMessageTestingAnimation,
    44: campaignImpactEvaluationAnimation,
    45: communicationCampaignImpactEvaluationAnimation,
    46: publicProgramImpactEvaluationAnimation,
    47: blindTastingAnimation,
    48: exportMarketVolumeEstimationAnimation,
    49: targetMarketIdentificationAnimation,
    50: exportMarketResearchAnimation,
    51: targetMarketPartnerIdentificationAnimation,
    20: npsAnimation,
    21: notorityAnimation,
    22: pyramidAnimation,
    23: atitudeAnimation,
    24: consumerProfileAnimation,
    25: segmentationAnimation,
    26: priceTestingAnimation,
    27: packageTestingAnimation,
    28: productTestAnimation,
    29: socialPhenomenonAnimation,
    30: socialEtnographyAnimation,
    31: testareaCandidatilorPoliticiAnimation,
    32: socialMassMediaAnimation,
    33: socialAcademicAnimation,
    34: longitudinalStudyAnimation,
    54: socialPopulationAnimation,
};

export const METHODOLOGY_ANIMATION_BY_ID = {
    1: methodologyQuantitativeAnimation,
    2: methodologyQualitativeAnimation,
    3: methodologyAnalysisAnimation,
    4: methodologyExperimentAnimation,
    5: methodologyOfficeAnimation,
    6: methodologyAdvancedAnimation,
};

export function resolveServiceAnimation(animationId) {
    const rawId =
        animationId && typeof animationId === "object"
            ? (animationId.value ?? animationId.id ?? animationId.animation_id)
            : animationId;
    const normalizedId = Number(rawId);

    if (!Number.isFinite(normalizedId)) {
        return null;
    }

    return SERVICE_ANIMATION_BY_ID[normalizedId] || null;
}

export function resolveMethodologyAnimation(animationId) {
    const rawId =
        animationId && typeof animationId === "object"
            ? (animationId.value ?? animationId.id ?? animationId.animation_id)
            : animationId;
    const normalizedId = Number(rawId);

    if (!Number.isFinite(normalizedId)) {
        return null;
    }

    return METHODOLOGY_ANIMATION_BY_ID[normalizedId] || null;
}

export function AnimatedVisualSwap({
    animationId,
    type = "service",
    className,
    ...props
}) {
    const rootRef = useRef(null);
    const mediaRef = useRef(null);
    const animation =
        type === "methodology"
            ? resolveMethodologyAnimation(animationId)
            : resolveServiceAnimation(animationId);

    useLayoutEffect(() => {
        const root = rootRef.current;
        const media = mediaRef.current;
        const renderFactory = RENDERERS[animation?.renderer];

        if (!root || !media || !renderFactory) {
            return undefined;
        }

        const {
            node,
            apply,
            speed,
            touchSpeed,
            leaveSpeed,
            touchLeaveSpeed,
        } = renderFactory(props);
        media.appendChild(node);
        const interactiveTarget =
            root.closest(
                ".servicesCards__card, .methodologiesCards__stackViewport__stackTrack__card, .methodology__container__navigation",
            ) || root;
        const cleanup = attachInteractive(interactiveTarget, apply, {
            speed,
            touchSpeed,
            leaveSpeed,
            touchLeaveSpeed,
        });

        return () => {
            cleanup();
            media.innerHTML = "";
        };
    }, [animation, props]);

    if (!RENDERERS[animation?.renderer]) {
        return null;
    }

    const rendererModifier = animation?.renderer
        ? `animatedVisualSwap--${String(animation.renderer).replace(/[^a-zA-Z0-9_-]/g, "-")}`
        : null;

    return (
        <div
            ref={rootRef}
            className={["animatedVisualSwap", rendererModifier, className]
                .filter(Boolean)
                .join(" ")}
        >
            <div ref={mediaRef} className="animatedVisualSwap__media" />
        </div>
    );
}

export default AnimatedVisualSwap;
